export default i => i && `${i.substring(0, i.length - 10)} (${i.substr(-10, 3)}) ${i.substr(-7, 3)}-${i.substr(-4, 4)}`;
